import React, { useState } from "react";
import api from "../../../../utils/api";
import MainNavbar from "../../MainNavbar";
import "./Compatibility.css";
import CompatibilityCard from "./CompatibilityCard";

export default function CompatibilityPage() {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const analyzeCompatibility = async () => {
    setLoading(true);
    setResult(null);

    try {
      const res = await api.post("/ai/compatibility");
      const text = res.data.analysis;

      // Split into sections for clean UI
      const sections = text.split("\n").filter(Boolean);

      setResult(sections);
    } catch (err) {
      setResult(["⚠️ Error fetching compatibility report. Try again."]);
    }

    setLoading(false);
  };

  return (
    <>
      <MainNavbar />

      <div className="compat-container">
        <h2 className="compat-title">Compatibility Analysis</h2>

        <button className="compat-btn" onClick={analyzeCompatibility} disabled={loading}>
          {loading ? "Analyzing..." : "Generate Compatibility Report"}
        </button>

        <div className="compat-results">
          {result &&
            result.map((section, idx) => (
              <CompatibilityCard key={idx} text={section} />
            ))}
        </div>
      </div>
    </>
  );
}
